import { useContext, useEffect, useState } from 'react';
import AuthContext from '../../contexts/auth-context';
import useAxios from '../../hooks/useAxios';
import { urls, app_paths, http_response_messages, toastify_status, patientFormType } from '../config/variables';
import classes from './NewUserForm.module.css';
import { Navigate, useParams } from 'react-router-dom';
import NewPatientSchema from '../schema/NewPatient.schema';
import {useTranslation} from 'react-i18next'
import CircularProgress from '@mui/material/CircularProgress';
import Toastify from '../ui/Toastify';
import { validateNewDoctorResponse } from '../../Utils/validateHttpResponse';
import SearchableSelect from '../ui/SearchableSelect/SearchableSelect';
import { nationalities } from '../../Utils/nationalaties';

function NewDoctorForm({type}) {
  const authCtx = useContext(AuthContext);
  const token = authCtx.token;
  const { operation } = useAxios();
  const {t} = useTranslation('newPatient')
  //const direction = appCtx.direction

  const [userResponse, setUserResponse] = useState(undefined);
  const [userError, setUserError] = useState(undefined);
  const [validationErrors, setValidationErrors] = useState({});
  const [loadingAddPatient, setLoadingAddPatient] = useState(false);

  // patient id ---> used to update a patient by doctor and insurance
  const { doctorID } = useParams();
  // fetched patient information ---> used to update the patient by doctor and insurance
  const [doctorInformation, srtDoctorInformation] = useState('')
  const [loadingDoctorInformation, setLoadingDoctorInformation] = useState(true)

  const [enteredName, setEnteredName] = useState('');
  const [enteredEmail, setEnteredEmail] = useState('');
  const [enteredPassword, setEnteredPassword] = useState('');
  const [enteredPhone, setEnteredPhone] = useState('');
  const [gender, setGender] = useState('')
  const [enteredBirthday, setEnteredBirthday] = useState('')

  const [nationality, setNationality] = useState('')
  const enterednationality = nationality.nationality;

  const [enteredEid, setEnteredEid] = useState('')
  const [enteredphysical_address, setEnteredphysical_address] = useState('')
  const [enteredemployer, setEnteredemployer] = useState('')

  const [license, setLicense] = useState('');

  const [department, setDepartment] = useState('');
  const enteredDepartment = department.value;

  const [division, setDivision] = useState('');
  const enteredDivision = division.value;


  // if form type is create then validate email and passeord
  const checkEmailAndPassword = () => {
    return !enteredEmail ||
    !enteredPassword
  }

  const isDisabled = //disabled submit button
    (type === patientFormType.create &&
    checkEmailAndPassword()) ||
    !enteredName ||
    !enteredBirthday ||
    !gender.gender ||
    !license ||
    !enteredDepartment ||
    Object.keys(validationErrors).length > 0;

  const validateField = (fieldId, value, otherValue) => {
    const { error } = NewPatientSchema.validate({ [fieldId]: value }, { abortEarly: false, context: {otherValue} });
    const errors = {};
    if (error) {
      for (const detail of error.details) {
        errors[detail.context.key] = detail.message;
      }
    }
    setValidationErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors, [fieldId]: errors };
      if (Object.keys(updatedErrors[fieldId]).length === 0) {
        delete updatedErrors[fieldId]; // Remove the fieldId if there are no errors
      }
      return updatedErrors;
    });
  };

  const submitHandler = (event) => {
    setLoadingAddPatient(true)
    event.preventDefault();
    const hasErrors = Object.values(validationErrors).some((fieldErrors) => Object.keys(fieldErrors).length > 0);
    if (hasErrors) {
      console.log(hasErrors);
      return;
    }
    const user = {
      name: enteredName,
      birthdate: enteredBirthday,
      gender: gender.gender,
      phone_number: enteredPhone,
      eid: enteredEid,
      physical_address: enteredphysical_address,
      employer: enteredemployer,
      nationality: enterednationality,
      ...(type === patientFormType.create && {
        email: enteredEmail,
        password: enteredPassword,
      })
    };

    operation(
      {
        method: type === patientFormType.create ? 'POST' : 'PATCH',
        url: type === patientFormType.create ? urls.CREATE_DOCTOR_PROFILE : urls.UPDATE_DOCTOR_PROFILE.replace(':doctorID', doctorID),
        headers: { Authorization: `token ${token}` },
        data: {
          user: user,
          license,
          department: enteredDepartment,
          division: enteredDivision,

        },
      },
      handleUserResponse,
      setUserError
    );
  };

  const handleUserResponse = (userResponst) => {
    setLoadingAddPatient(false)

    if(validateNewDoctorResponse(userResponst)) {
      setUserResponse(userResponst)
      setUserError(undefined)
      showSuccessMessage()
    } else {
      Toastify({message: 'invalid user response', state: toastify_status.ERROR})
      console.log('invalid user response')
    }
  }

  const showSuccessMessage = () => {
    if(type === patientFormType.create) {
      Toastify({message: http_response_messages.CREATE_DOCTOR, state: toastify_status.SUCCESS})
    } else {
      Toastify({message: http_response_messages.UPDATE_DOCTOR, state: toastify_status.SUCCESS})
    }
  }

    /* If user is not created successfully, show the error message */
  useEffect(() => {
    if (userError) {
      if (userError.response.data) {
        const errors = userError.response.data.errors
        errors.map((error) => (
          Toastify({ message: error.detail, state: toastify_status.ERROR })
        ))
      } else {
        Toastify({ message: http_response_messages.ERROR, state: toastify_status.ERROR })
      }
    }
    setLoadingAddPatient(false)
  }, [userError]);

  const handleFormReset = (event) => {
    event.preventDefault();

    setValidationErrors({});
    //To be cleared when defaultValues are removed
    setEnteredName('')
    setEnteredEmail('')
    setEnteredPhone('')
    setGender('')
    setEnteredBirthday('')
    setNationality('')
    setDepartment('')
    setDivision('')
    setEnteredEid('')
    setEnteredphysical_address('')
    setEnteredemployer('')
    setLicense('')
  };

const goSomeWhere = (userResponse) => {
    if(type === patientFormType.create) {
      console.log("Role: Doctor, navigate to new encounter")
      return  <Navigate to={app_paths.DOCTOR_LIST} replace={true} />
    } else {
      // return <Navigate to={app_paths.PATIENT_PROFILE.replace(':patientID', userResponse.id)} replace={true} />
    }
}

const handleChangeNationality = (value) => {
  validateField('nationality', value.nationality)
  setNationality(value)
}

const handleChangeGender = (value) => {
  validateField('gender', value.gender)
  setGender(value)
}

const handleChangeDepartment = (value) => {
  validateField('department', value.value)
  setDepartment(value)
}

const handleChangeDivision = (value) => {
  validateField('division', value.value)
  setDivision(value)
}

// get the patient information to update it by doctor and insurance
const getDoctorFromDoctorID = () => {
  operation(
    {
      method: 'GET',
      url: urls.GET_SINGLE_DOCTOR_PROFILE.replace(':doctorID', doctorID),
      headers: { Authorization: `token ${token}` },
      data: {},
    },
    handleSetDoctorInformation,
    handleErrorDoctorInformation
  );
}

const handleSetDoctorInformation = (doctorInfo) => {
  setLoadingDoctorInformation(false)
  if(validateNewDoctorResponse(doctorInfo)) {
    srtDoctorInformation(doctorInfo)
  } else {
    Toastify({message: 'invalid user response', state: toastify_status.ERROR})
  }
}

const handleErrorDoctorInformation = (error) => {
  setLoadingDoctorInformation(false)
  Toastify({message: 'Error fetching patient information', state: toastify_status.ERROR})
}

useEffect(() => {
  if(doctorID) {
    getDoctorFromDoctorID()
  }
  // eslint-disable-next-line
}, [doctorID])

useEffect(() => {
  if (
    type === patientFormType.update &&
    doctorID &&
    doctorInformation
  ) {

    const {
      name,
      email,
      phone_number,
      gender,
      birthdate,
      nationality,
      eid,
      physical_address,
      employer,
    } = doctorInformation.user;

    const {department: gottedDepartment, division: gottedDivision, license: gottedLicense} = doctorInformation;

    setEnteredName(name)
    setEnteredEmail(email)
    setEnteredPhone(phone_number)
    setGender(gender === 'M' ? { name: "Male", gender: "M" } : { name: "Female", gender: "F" })
    setEnteredBirthday(birthdate)
    setNationality(nationality ? { nationality: nationality } : '')
    setEnteredEid(eid)
    setEnteredphysical_address(physical_address)
    setEnteredemployer(employer)
    setDepartment(() => departments.find((dept) => dept.value === gottedDepartment))
    setDivision(() => divisions.find((div) => div.value === gottedDivision))
    setLicense(gottedLicense)
  }
  // eslint-disable-next-line
}, [type, doctorID, doctorInformation]);

const handleChangeField = (event) => {
  const {id, value} = event.target
  validateField(id, value)
  switch (id) {
    case 'email':
      setEnteredEmail(value);
      break;
    case 'name':
      setEnteredName(value);
      break;
    case "password":
      setEnteredPassword(value);
      break;
    case 'phone_number':
      setEnteredPhone(value);
      break;
    case 'birthdate':
      setEnteredBirthday(value);
      break;
    case 'eid':
      setEnteredEid(value);
      break;
    case 'physical_address':
      setEnteredphysical_address(value);
      break;
    case 'employer':
    setEnteredemployer(value);
      break;
    case 'license':
      setLicense(value);
      break;
    default:
      return null;
  }
}

const departments = [
  { value: 'INTERNAL_MEDICINE', label: 'Internal Medicine' },
  { value: 'SURGERY', label: 'Surgery' },
  { value: 'PEDIATRICS', label: 'Pediatrics' },
  { value: 'OB_GYN', label: 'Ob Gyn' },
  { value: 'EMERGENCY', label: 'Emergency' },
  { value: 'RADIOLOGY', label: 'Radiology' },
  { value: 'PATHOLOGY', label: 'Pathology' },
  { value: 'ANESTHESIOLOGY', label: 'Anesthesiology' },
  { value: 'FAMILY_MEDICINE', label: 'Family Medicine' },
  { value: 'OTHER', label: 'Other' }
];

const divisions = [
  { value: 'OUTPATIENT', label: 'Outpatient' },
  { value: 'INPATIENT', label: 'Inpatient' },
  { value: 'CRITICAL_CARE', label: 'Critical Care' },
  { value: 'DIAGNOSTICS', label: 'Diagnostics' },
  { value: 'REHABILITATION', label: 'Rehabilitation' },
  { value: 'RESEARCH', label: 'Research' },
  { value: 'ADMINISTRATION', label: 'Administration' },
  { value: 'OTHER', label: 'Other' }
];

  return (
    <div className={classes.container}>
      <form onReset={handleFormReset} onSubmit={submitHandler}>
        <div>
          <h1 className={classes.title}>Doctor information</h1>
          <div className={classes.form_container}>
            <div className={classes.control}>
              <label htmlFor="name">{t('Name')} <span className={classes.required}>*</span></label>
              <input
                type="text"
                id="name"
                placeholder="John Doe"
                value={enteredName}
                onChange={handleChangeField}
              />
              {validationErrors.name && <p className={classes.helperText}>{validationErrors.name.name}</p>}
            </div>

            <div className={classes.control}>
              <label htmlFor="email">{t('UserEmail')} <span className={classes.required}>*</span></label>
              <input
                type="email"
                id="email"
                placeholder="example@example.com"
                value={enteredEmail}
                onChange={handleChangeField}
                disabled={type === patientFormType.update}
              />
              {validationErrors.email && <p className={classes.helperText}>{validationErrors.email.email}</p>}
            </div>

            {type === patientFormType.create && <div className={classes.control}>
              <label htmlFor="password">{t('UserPassword')} <span className={classes.required}>*</span></label>
              <input
                type="password"
                id="password"
                placeholder="********"
                value={enteredPassword}
                onChange={handleChangeField}
              />
              {validationErrors.password && <p className={classes.helperText}>{validationErrors.password.password}</p>}
            </div>}

            <div className={classes.searchable}>
              <label htmlFor="gender">{t('Gender')} <span className={classes.required}>*</span></label>
              <SearchableSelect
                  value={gender}
                  onChange={handleChangeGender}
                  options={[{name: t('Male'), gender: 'M'}, {name: t('Female'), gender: 'F'}]}
                  placeholder={'Select Gender'}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.gender}
                  searchable={false}
                />
                {validationErrors.gender && <p className={classes.helperText}>{validationErrors.gender.gender}</p>}
            </div>

            <div className={classes.control}>
              <label htmlFor="birthdate">{t('Birthdate')} <span className={classes.required}>*</span></label>
              <input
                type="date"
                id="birthdate"
                placeholder="YYYY-MM-DD (e.g., 1990-01-01)"
                value={enteredBirthday}
                onChange={handleChangeField}
              />
              {validationErrors.birthdate && <p className={classes.helperText}>{validationErrors.birthdate.birthdate}</p>}
            </div>

            <div className={classes.control}>
              <label htmlFor="license">License <span className={classes.required}>*</span></label>
              <input
                type="text"
                id="license"
                placeholder="license"
                value={license}
                onChange={handleChangeField}
              />
              {validationErrors.license && <p className={classes.helperText}>{validationErrors.license.license}</p>}
            </div>

            <div className={classes.searchable}>
              <label htmlFor="department">department <span className={classes.required}>*</span></label>
              <SearchableSelect
                  value={department}
                  onChange={handleChangeDepartment}
                  options={departments}
                  placeholder={'Select department'}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                />
                {validationErrors.department && <p className={classes.helperText}>{validationErrors.department.department}</p>}
            </div>

            <div className={classes.searchable}>
              <label htmlFor="division">division</label>
              <SearchableSelect
                  value={division}
                  onChange={handleChangeDivision}
                  options={divisions}
                  placeholder={'Select division'}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                />
                {validationErrors.division && <p className={classes.helperText}>{validationErrors.division.division}</p>}
            </div>

            <div className={classes.control}>
              <label htmlFor="phone_number">{t('Phone')}</label>
              <input
                type="text"
                id="phone_number"
                placeholder="+1234567890"
                value={enteredPhone}
                onChange={handleChangeField}
              />
              {validationErrors.phone_number && <p className={classes.helperText}>{validationErrors.phone_number.phone_number}</p>}
            </div>

            <div className={classes.searchable}>
              <label htmlFor="nationality">{t('Nationality')}</label>
              <SearchableSelect
                  value={nationality}
                  onChange={handleChangeNationality}
                  options={nationalities}
                  placeholder={'Select nationality'}
                  getOptionLabel={(option) => option.nationality}
                  getOptionValue={(option) => option.nationality}
                />
                {validationErrors.nationality && <p className={classes.helperText}>{validationErrors.nationality.nationality}</p>}
            </div>

            <div className={classes.control}>
              <label htmlFor="eid">{t('GovernmentID')}</label>
              <input
                type="text"
                id="eid"
                placeholder="A12345678"
                value={enteredEid}
                onChange={handleChangeField}
              />
              {validationErrors.eid && <p className={classes.helperText}>{validationErrors.eid.eid}</p>}
            </div>

            <div className={classes.control}>
              <label htmlFor="physical_address">{t('PhysicalAddress')}</label>
              <input
                type="text"
                id="physical_address"
                placeholder="123 Main Street, City, State"
                value={enteredphysical_address}
                onChange={handleChangeField}
              />
              {validationErrors.physical_address && (
                <p className={classes.helperText}>{validationErrors.physical_address.physical_address}</p>
              )}
            </div>

            <div className={classes.control}>
              <label htmlFor="employer">{t('Employer')}</label>
              <input
                type="text"
                id="employer"
                placeholder="ABC Company"
                value={enteredemployer}
                onChange={handleChangeField}
              />
              {validationErrors.employer && <p className={classes.helperText}>{validationErrors.employer.employer}</p>}
            </div>
          </div>

          <div className={classes.space} />
        </div>

        <div className={classes.actions_container}>
          <div className={[classes.actions, classes.actions_add].join(' ')}>
            <button type="submit" disabled={isDisabled}>
              {type === patientFormType.create ? 'Add Doctor' : 'Update Doctor'}
            </button>
          </div>
          {loadingAddPatient && (
            <div className={[classes.actions]}>
            <CircularProgress/>
          </div>
          )}
          <div className={[classes.actions, classes.actions_clear].join(' ')}>
            <button onClick={handleFormReset}>{t('Clear')}</button>
          </div>
        </div>
        {userResponse && !userError && goSomeWhere(userResponse)}
      </form>
      {type === patientFormType.update && loadingDoctorInformation &&
        <div className={classes.loading}>
          <CircularProgress />
        </div>}
    </div>
  );
}

export default NewDoctorForm;